module.exports = __webpack_public_path__ + "img/icon-sync white.72f906cd.svg";